import React, { memo } from 'react';
import { Tooltip, ITooltip } from 'react-tooltip';
import { ExternalTooltipV2Props } from './atoms/TooltipV2/TooltipV2Types';
import { classnames } from '@/libs/utils';

const TooltipV2 = ({
  tooltipElement,
  tooltipContent,
  tooltipId,
  size = 'xxsmall',
  colorTheme = 'dark',
  className,
  ...tooltipProps
}: ITooltip &
  ExternalTooltipV2Props & {
    tooltipElement?: React.ReactNode;
    size?: 'xxsmall' | 'xsmall' | 'base';
    colorTheme?: 'light' | 'dark';
    className?: string;
  }) => {
  const isLightTheme = colorTheme === 'light';

  return (
    <div style={{ display: 'inline-block' }}>
      {tooltipElement && <div data-tooltip-id={tooltipId}>{tooltipElement}</div>}

      <Tooltip
        id={tooltipId}
        {...tooltipProps}
        noArrow={true}
        className={classnames(
          'max-w-[250px]',
          isLightTheme
            ? 'rounded-md border border-slate-200 bg-white px-2 py-1 text-black'
            : 'bg-black px-1.5 py-1 leading-tight text-white',
          size === 'xxsmall' ? 'text-2xs' : size === 'xsmall' ? 'text-xs' : size === 'base' ? 'text-base' : '',
          className || ''
        )}
      >
        {tooltipContent}
      </Tooltip>
    </div>
  );
};

export default memo(TooltipV2);
